import React from 'react';

const DashBoardHome = () => {
  return (
    <div className='shadow-lg h-100'>
      <h1  className=' bg-dark text-light'>DashBoard </h1>
      <h4 className='mt-5'>Dashboard feature is coming ...</h4>
    </div>
  );
};

export default DashBoardHome;